
import React from 'react';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Poll } from '@/types/poll';

interface PollBasicInfoFieldsProps {
  currentPoll: Poll;
  updateField: (field: keyof Poll, value: any) => void;
}

const PollBasicInfoFields: React.FC<PollBasicInfoFieldsProps> = ({ currentPoll, updateField }) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="title">Poll Title</Label>
        <Input
          id="title"
          value={currentPoll.title}
          onChange={(e) => updateField('title', e.target.value)}
          placeholder="e.g., Should the government increase education funding?"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="description">Description</Label>
        <Textarea
          id="description"
          value={currentPoll.description}
          onChange={(e) => updateField('description', e.target.value)}
          placeholder="Provide context for the poll question"
          rows={3}
        />
      </div>
    </>
  );
};

export default PollBasicInfoFields;
